import axios from "axios";

let location = window.location.origin;
const API = `${location}/api/validatePassword`;

export default {
    get(data) {
        return axios.post(API, data);
    },
    create(data) {}
};